import React from "react";
import { Link } from "react-router-dom";
import { MdLock, MdPalette, MdTextFields, MdImage, MdLink } from "react-icons/md";
import UpgradeFeatureItem from "./UpgradeFeatureItem";
import { TabKeys, URL_TAB_PARAM_KEY as SUBSCRIPTION_URL_TAB_PARAM_KEY } from "../../GroupSubscription/utils";
import { LanguageText } from "../../../../dictionary/GroupsText";
import useGetLanguage from "../../../../utils/useGetLanguage";

interface GroupStyleUpgradePromptProps {
  groupId: string;
}

const GroupStyleUpgradePrompt: React.FC<GroupStyleUpgradePromptProps> = ({ groupId }) => {

  const language: LanguageText = useGetLanguage({
    fileName: "GroupsText",
  });

  const FEATURES = [
    {
      icon: <MdPalette className="w-4 h-4 sm:w-5 sm:h-5 text-blue-600" />,
      title: language?.groupStyle?.components?.GroupStyleUpgradePrompt?.features?.frameColor?.title || '',
      description: language?.groupStyle?.components?.GroupStyleUpgradePrompt?.features?.frameColor?.description || ''
    },
    {
      icon: <MdTextFields className="w-4 h-4 sm:w-5 sm:h-5 text-blue-600" />,
      title: language?.groupStyle?.components?.GroupStyleUpgradePrompt?.features?.siteName?.title || '',
      description: language?.groupStyle?.components?.GroupStyleUpgradePrompt?.features?.siteName?.description || ''
    },
    {
      icon: <MdImage className="w-4 h-4 sm:w-5 sm:h-5 text-blue-600" />,
      title: language?.groupStyle?.components?.GroupStyleUpgradePrompt?.features?.logo?.title || '',
      description: language?.groupStyle?.components?.GroupStyleUpgradePrompt?.features?.logo?.description || ''
    },
    {
      icon: <MdLink className="w-4 h-4 sm:w-5 sm:h-5 text-blue-600" />,
      title: language?.groupStyle?.components?.GroupStyleUpgradePrompt?.features?.useAtLogin?.title || '',
      description: language?.groupStyle?.components?.GroupStyleUpgradePrompt?.features?.useAtLogin?.description || ''
    },
  ];

  return (
    <div className="w-full max-w-full min-w-0 px-1 sm:px-2 md:px-3">
      <div className="flex flex-col items-center gap-y-2 sm:gap-y-3 md:gap-y-4 max-w-[280px] sm:max-w-[320px] md:max-w-[360px] w-full min-w-0 mx-auto bg-gradient-to-br from-blue-50 to-indigo-50 rounded-md sm:rounded-lg shadow p-2 sm:p-3 md:p-4 border border-blue-200">
        <div className="flex items-center justify-center w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-blue-100 border-2 border-blue-200">
          <MdLock className="w-5 h-5 sm:w-6 sm:h-6 text-blue-600" />
        </div>

        <div className="text-center">
          <h2 className="text-base sm:text-lg font-semibold text-gray-900 mb-0.5">
            {language?.groupStyle?.components?.GroupStyleUpgradePrompt?.title}
          </h2>
          <p className="text-xs sm:text-sm text-gray-600">
            {language?.groupStyle?.components?.GroupStyleUpgradePrompt?.subtitle}
          </p>
        </div>

        <div className="w-full space-y-1.5 sm:space-y-2">
          {FEATURES.map((f, i) => (
            <UpgradeFeatureItem
              key={i}
              icon={f.icon}
              title={f.title}
              description={f.description}
            />
          ))}
        </div>

        <Link
          to={`/group/${groupId}/subscription?${SUBSCRIPTION_URL_TAB_PARAM_KEY}=${TabKeys.PLANS}`}
          className="w-full sm:w-auto px-4 sm:px-6 py-1.5 sm:py-2 rounded-md bg-blue-600 hover:bg-blue-700 text-white font-medium text-xs sm:text-sm shadow transition flex items-center justify-center gap-1.5"
        >
          <span>{language?.groupStyle?.components?.GroupStyleUpgradePrompt?.linkToAvailablePlans}</span>
          <svg
            className="w-3.5 h-3.5 sm:w-4 sm:h-4"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M13 7l5 5m0 0l-5 5m5-5H6"
            />
          </svg>
        </Link>
      </div>
    </div>
  );
};

export default GroupStyleUpgradePrompt;
